'use client';
import { useState } from 'react';

/**
 * CopyIdButton — tiny inline copy-to-clipboard button
 *
 * Props:
 *  text   {string}  — text to copy
 *  dark   {boolean} — use white-tinted icon (for dark bg); default false (grey)
 */
export const CopyIdButton = ({ text, dark = false, label = 'ID' }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e) => {
        e.stopPropagation();
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        }).catch(() => {});
    };

    return (
        <button
            onClick={handleCopy}
            title={copied ? 'Copied!' : `Copy ${label}`}
            style={{
                background:  'none',
                border:      'none',
                padding:     '1px 3px',
                margin:      0,
                cursor:      'pointer',
                display:     'inline-flex',
                alignItems:  'center',
                flexShrink:  0,
                color:       copied
                    ? '#4ade80'
                    : dark
                        ? 'rgba(255,255,255,0.35)'
                        : '#9ca3af',
                transition:  'color 0.18s',
                lineHeight:  1,
            }}
            onMouseEnter={e => { if (!copied) e.currentTarget.style.color = dark ? 'rgba(255,255,255,0.65)' : '#6b7280'; }}
            onMouseLeave={e => { if (!copied) e.currentTarget.style.color = dark ? 'rgba(255,255,255,0.35)' : '#9ca3af'; }}
        >
            <i
                className={`pi ${copied ? 'pi-check' : 'pi-copy'}`}
                style={{ fontSize: '0.68rem' }}
            />
        </button>
    );
};
